import Actions from "./Actions";
import Role from "./Role";

const memberComponents = {
  Actions,
  Role
}

export default memberComponents